import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PrimaryValueChangeDropdown from './primary-value-change-dropdown';
import {
  changePrimaryEmailInProspectRequest,
  updatePrimaryNumberRequest,
} from '../../../../../../extra-actions';
import { PrimaryValueChangeDropdownContainerProps } from './types';
import { RootState } from '../../../../../../../../store/root-reducer';

const PrimaryValueChangeDropdownContainer: React.FC<PrimaryValueChangeDropdownContainerProps> = ({
  options,
  tooltipText,
  modalTitle,
  modalContent,
  initialSelectedValue,
  contactId,
}) => {
  const dispatch = useDispatch();

  const changePrimaryEmailsInProspect = (
    contactIdParam: number,
    primaryEmailProspectInfoId: number,
  ) => {
    dispatch(
      changePrimaryEmailInProspectRequest({
        contactId: contactIdParam,
        primaryEmailProspectInfoId,
      }),
    );
  };

  const updatePrimaryNumbers = (
    contactIdParam: number,
    primaryPhoneProspectInfoId: number,
  ) => {
    dispatch(
      updatePrimaryNumberRequest({
        contactId: contactIdParam,
        primaryPhoneProspectInfoId,
      }),
    );
  };

  const getPrimaryEmailChange = useSelector(
    (state: RootState) => state.prospect.changePrimaryEmailInProspectRequest.status
  );

  const getUpdatePrimaryNumber = useSelector(
    (state: RootState) => state.prospect.updatePrimaryNumberRequest.status
  );

  return (
    <PrimaryValueChangeDropdown
      options={options}
      tooltipText={tooltipText}
      modalTitle={modalTitle}
      modalContent={modalContent as string}
      initialSelectedValue={initialSelectedValue}
      contactId={contactId}
      changePrimaryEmailsInProspect={changePrimaryEmailsInProspect}
      updatePrimaryNumbers={updatePrimaryNumbers}
      getPrimaryEmailChange={getPrimaryEmailChange}
      getUpdatePrimaryNumber={getUpdatePrimaryNumber}
    />
  );
};

export default PrimaryValueChangeDropdownContainer;
